import { Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { treemapResquarify } from 'd3';
import { BaseComponent } from 'src/app/shared/baseComponent';
import { Geoutil } from 'src/app/shared/geoutil';
import { Google_map } from 'src/app/shared/google_map';
import { Gps } from 'src/app/shared/gps';

@Component({
  selector: 'app-simulation',
  templateUrl: './simulation.component.html',
  styleUrls: ['./simulation.component.css']
})
export class SimulationComponent extends BaseComponent implements OnInit {
  @ViewChild('pagemap', { static: true }) mapElement: any = {}
  // @ViewChild('alarm1') alarm1Element: any = {}
  // @ViewChild('alarm2') alarm2Element: any = {}
  @ViewChild('audioPlayer', { static: false }) audioPlayer: ElementRef;
  scenario: any = {}
  scenariolayout: any = { contours: [] }
  scenarioid = ""
  google_map: Google_map
  gps: Gps
  counter = 0
  currentContourId = 0;
  debug = false
  distance = 0
  nInterval: any
  gpslog: any = { id: 0, organizationid: 1, latitude: 0, longitude: 0, accuracy: 0, phoneinfo: "1", height: 0 }
  phoneinfo = ""
  scenariosensors: any = []
  showSelection = true
  teamname = ""
  readingtestdebug = 0 //for testing only to overwrite readings
  testAlarmFlag = false;
  audioSrc = '../../assets/5beeps.wav'
  alarmColor = "red" //"white"
  isActiveScan = false
  hasFirstGPSSignal = false
  currentAccuracy = -1.0

  constructor(injector: Injector) { super(injector) }

  async ngOnInit() {

    this.gps = new Gps();
    let id = this.getIntQueryParamOrDefault("id", 0)
    if (id > 0) this.scenarioid = id.toString()

  }

  async getData() {
    this.scenario = await this.db.get("scenario", "getscenario", { id: this.scenarioid });
    this.scenariosensors = await this.db.get("scenariosensor", "getscenariosensorsbyscen", { scenarioid: this.scenarioid })
    this.scenariosensors.forEach((ss: any) => ss.reading = 0 );
    if (this.scenario.geometryJson.length > 5) {
      this.scenariolayout = JSON.parse(this.scenario.geometryJson);
      //this.showMap();
    }

  }
  async start() {
    this.hasFirstGPSSignal = false
    this.gpslog.phoneinfo = this.randomString(6)
    if (this.teamname.length > 1) this.gpslog.phoneinfo = this.teamname 
    this.gpslog.scenarioid = this.scenarioid
    this.loader.show()
    await this.getData()
    if (this.debug || this.readingtestdebug > 0) {
      this.updateDebugLocations()
    } else {
      this.gps.updateLocation(this.updateLocationCallback.bind(this)); //callbacks need a bind
    }
    this.loader.hide()
    this.showSelection = false;
    this.isActiveScan = true
  }

  showMap() {
    this.google_map = new Google_map()
    let latlng = this.scenariolayout.center
    this.google_map.init(this.mapElement.nativeElement, latlng, 15)
    this.google_map.setMarker(latlng, "Center");
    this.scenariolayout.contours.forEach((p: any, i: number) => {
      let color = this.scenariolayout.contourdefinitions[i].color;
      this.google_map.addPolygon(p, color)
    })
  }

  async updateLocationCallback(latlng: any) {
    this.hasFirstGPSSignal = true;
    if (!this.isActiveScan) return // only process is activerun
    this.counter += 1
    //this.google_map.addCircle(latlng, 2, "#0909FF");
    this.distance = Geoutil.getDistance(this.scenariolayout.center, latlng);

    let dbArray:any = []
    this.currentContourId = this.scenariolayout.contours.length - 1;
    for (let i = this.scenariolayout.contours.length - 1; i >= 0; i--) {
      let isInPoly = Geoutil.pointInPolygon(this.scenariolayout.contours[i], latlng);
      dbArray.push({contourId: i, inPoly: isInPoly})
      if (isInPoly) {
        this.currentContourId = i
      }
    }

    this.gpslog.latitude = latlng.lat
    this.gpslog.longitude = latlng.lng
    this.gpslog.accuracy = latlng.acc
    this.gpslog.height = this.scenariolayout.contourdefinitions[this.currentContourId].exposure
    this.currentAccuracy = this.gpslog.accuracy
    
    //this.gpslog.height = 100; // just for debugging !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    let generalAlarm = false
    this.scenariosensors.forEach((ss: any, index: number) => {
      this.setReading(ss,this.gpslog.height)
      if (ss.alarm) generalAlarm = true
    });

    if (generalAlarm) {
      this.alarmColor = "red"
      this.startAudio()
    } else {
      this.alarmColor = "white"
      this.stopAudio()
    }

    let newVersionId = await this.db.post("gpslog", "postgpslog", this.gpslog)
    if (newVersionId.versionId != this.scenario.versionId){
      await this.getData()
    }
    //this.alert.success("Counter: " + this.counter + ", Distance " + this.distance.toFixed(1) + " meter; In Poly: " + this.currentContourId + "; Value: " + this.scenariolayout.contourdefinitions[this.currentContourId ].exposure);
  }
  setReading(ss:any,height: number){
    if (ss.sensorname == "O2"){
      if (ss.gpsMaxReading >= 20.9){
        ss.reading = 20.9 + (ss.gpsMaxReading - 20.9)*height/100
        ss.alarm = ss.reading > ss.threshold ? true : false
      }else{
        ss.reading = 20.9 + (ss.gpsMaxReading - 20.9)*height/100
        ss.alarm = ss.reading < ss.threshold ? true : false
      }
    }else{
      ss.reading = height * ss.gpsMaxReading / 100
      ss.alarm = ss.reading > ss.threshold ? true : false
    }
  }

  updateDebugLocations() {
    let latlng = { lat: this.scenariolayout.center.lat, lng: this.scenariolayout.center.lng }
    if (!this.nInterval) {
      this.nInterval = setInterval(() => {
        this.updateLocationCallback(latlng) //Call the same function as the gps
        latlng = Geoutil.getDifLAtLong(latlng, 5, 1) //move east
      }, 1000);
    }
  }


  stop() {
    // clearInterval(this.nInterval)
    this.isActiveScan = false
    this.showSelection = true;
    // this.alarm1Element.endBlink()
    // this.alarm2Element.endBlink()
    this.stopAudio()
    this.alarmColor = "white"
  }

  gotoShowMap() {
    this.router.navigate(['simdebug'])
  }

  getCurrentDateString() {
    const currentDate = new Date();

    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const day = currentDate.getDate().toString().padStart(2, '0');
    const hours = currentDate.getHours().toString().padStart(2, '0');
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');

    const formattedDate = `${year}/${month}/${day}:${hours}-${minutes}`;
    return formattedDate
  }
  testAlarm() {
    this.testAlarmFlag = !this.testAlarmFlag
    if (this.testAlarmFlag) {
      // this.alarm1Element.startblink()
      // this.alarm2Element.startblink()
      this.alarmColor = "red"
      this.startAudio()
    } else {
      // this.alarm1Element.endBlink()
      // this.alarm2Element.endBlink()
      this.alarmColor = "white"
      this.stopAudio()
    }
  }

  startAudio() {
    this.audioPlayer.nativeElement.loop = true
    this.audioPlayer.nativeElement.play()
  }
  stopAudio() {
    this.audioPlayer.nativeElement.loop = false
  }
  debugCallback(){
    this.updateLocationCallback({lat:40,lng:-78,acc:10})
  }
}
